import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState, useMemo } from 'react';
import { FlexContainer } from '../../layout/FlexContainer';
import { buildGroupedData } from './helpers/buildGroupedData';
import { renderGroupedData } from './helpers/renderGroupedData';
export const ExpansionTableWithDates = ({ data, columns, defaultExpandedKey, dateGroupingFunctions, rowHeaderTestId, hasAllRowsExpanded, rowDateKeyExtractor, rowKeyExtractor, renderDetail, renderLeftRowElement, onExpand, getHasRowDetail, }) => {
    const [expandedKey, setExpandedKeyState] = useState(defaultExpandedKey ?? undefined);
    useEffect(() => {
        setExpandedKeyState(defaultExpandedKey ?? undefined);
    }, [defaultExpandedKey]);
    const setExpandedKey = (key) => {
        setExpandedKeyState(key);
        onExpand?.(key);
    };
    const builtGroupData = useMemo(() => buildGroupedData(data, 0, dateGroupingFunctions, rowDateKeyExtractor), [data, dateGroupingFunctions, rowDateKeyExtractor]);
    const mappedRows = renderGroupedData(builtGroupData, {
        columns,
        rowKeyExtractor,
        expandedKey,
        hasAllRowsExpanded,
        renderDetail,
        setExpandedKey,
        renderLeftRowElement,
        rowHeaderTestId,
        getHasRowDetail,
    });
    return (_jsx(FlexContainer, { direction: 'column', gap: true, children: mappedRows }));
};
